// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-carousel/accolades-carousel.component.scss
// module id = 70
// module chunks = 0